import { Injectable, EventEmitter } from '@angular/core';    
import { Subscription } from 'rxjs/internal/Subscription';    
    
@Injectable({    
  providedIn: 'root'    
})    
export class EventEmitterService {    
    
    invokeUpdateNotification = new EventEmitter();    
    subsVar: Subscription;    
    
  constructor() { }    
    
  notificationUpdate() {    
    this.invokeUpdateNotification.emit();    
  }    

}    